import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectNewChat,
  selectSpaceFullScreen,
  turnOffFocus,
  turnOnFocus,
  turnOnPreFocus,
} from "slices/spaceSlice";
import {
  selectMeFocus,
  selectNumPeople,
  selectSpaceBoxActive,
  selectSpaceSideBar,
  setSpaceSidebar,
  SPACE_CHAT,
  SPACE_PEOPLE,
} from "slices/spaceMediaSlice";
import FocusCall from "graphics/icons/MediaControls/SpaceControls/FocusCall";
import UnFocusCall from "graphics/icons/MediaControls/SpaceControls/UnFocusCall";
import EfsTippy from "components/HOCS/EfsTippy";
import ChangeSpaceActive from "components/Home/Space/ChangeSpaceActive/ChangeSpaceActive";
import SpaceBubbles from "graphics/icons/Space/SpaceBubbles";
import SpaceChatIcon from "graphics/icons/Space/SpaceChatIcon";
import NotifierTippy from "components/HOCS/NotifierTippy";

const RemoteMediaControls = () => {
  const dispatch = useDispatch();
  const spaceFullScreen = useSelector(selectSpaceFullScreen);
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  const meFocus = useSelector(selectMeFocus);
  const ppl = useSelector(selectNumPeople);
  const spaceSideBar = useSelector(selectSpaceSideBar);
  const newChat = useSelector(selectNewChat);

  return (
    <div className="remote-media-controls">
      {!spaceFullScreen && !spaceBoxActive ? (
        <ChangeSpaceActive />
      ) : (
        <div className="d-flex justify-content-around align-items-center h-100">
          <EfsTippy
            content={`${meFocus ? "Connect" : "Disconnect"}`}
            placement="bottom"
            className="small-Tippy grey-Tippy"
            offset={[0, 0]}
            delay={[0, 0]}
          >
            <button
              className={`togglers  ${meFocus ? "active" : ""}`}
              onClick={() => {
                if (meFocus) {
                  turnOnPreFocus();
                  turnOffFocus();
                } else turnOnFocus();
              }}
            >
              {meFocus ? <UnFocusCall /> : <FocusCall />}
            </button>
          </EfsTippy>
          <EfsTippy
            content="Occupants"
            placement="bottom"
            className="small-Tippy grey-Tippy"
            offset={[0, 0]}
            delay={[0, 0]}
          >
            <button
              onClick={() =>
                dispatch(
                  setSpaceSidebar(
                    spaceSideBar === SPACE_PEOPLE ? null : SPACE_PEOPLE
                  )
                )
              }
              className={`togglers  ${
                spaceSideBar === SPACE_PEOPLE ? "active" : ""
              }`}
            >
              <span>
                <SpaceBubbles />
              </span>
              <span className="num">{ppl}</span>{" "}
            </button>
          </EfsTippy>
          <NotifierTippy>
            <EfsTippy
              content="Live Chat"
              placement="bottom"
              className="small-Tippy grey-Tippy"
              offset={[0, 0]}
              delay={[0, 0]}
            >
              <button
                onClick={() =>
                  dispatch(
                    setSpaceSidebar(
                      spaceSideBar === SPACE_CHAT ? null : SPACE_CHAT
                    )
                  )
                }
                className={`togglers ${
                  spaceSideBar === SPACE_CHAT ? "active" : ""
                } ${newChat ? "bright" : ""}`}
              >
                <span>
                  <SpaceChatIcon />
                </span>
                {newChat && <span className="num">●</span>}
              </button>
            </EfsTippy>
          </NotifierTippy>
        </div>
      )}
    </div>
  );
};
export default RemoteMediaControls;
